import { Grid, Link, SxProps, Theme } from '@mui/material';
import { IconButton } from 'components/Elements/Buttons/IconButton';
import { VbiLogo } from 'components/Elements/Buttons/VbiLogo';

export interface HeaderProps {
  sx?: SxProps<Theme>;
}

export const Header: React.FC<HeaderProps> = () => {
  return (
    <Grid
      container
      wrap="nowrap"
      paddingX={{ xs: 0, lg: 12 }}
      paddingY={3}
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        margin: 0,
      }}
    >
      <Grid item>
        <IconButton disableRipple sx={{ margin: 0, p: 0 }} href="https://vabirthinjury.com/">
          <VbiLogo height={72} />
        </IconButton>
      </Grid>
      <Grid item paddingRight={{ xs: 3, md: 0 }}>
        <Link
          href="https://vabirthinjury.com/contact/"
          variant="body1"
          sx={{
            color: 'primary.main',
            textDecoration: 'none',
            fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
            fontWeight: 500,
          }}
        >
          Contact
        </Link>
      </Grid>
    </Grid>
  );
};
